import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull, validatePorcentagem } from "@/functions/Util";

export default class FinanceiroValidation extends DefaultValidation{
  validate(model, refs) {
    let validated = true;

    Object.entries(model).forEach(([key, value]) => {
      if(value!=null && typeof value == "string") model[key] = value.trim();
    });

    if (isNull(model.idprazopagto)||model.idprazopagto==0) {
      refs.prazoPagtoSelect.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idformapagto)||model.idformapagto==0) {
      refs.formaPagtoSelect.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idtabpreco)||model.idtabpreco==0) {
      refs.tabPrecoVendaSelect.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idtabprecotroca)||model.idtabprecotroca==0) {
      refs.tabPrecoTrocaSelect.focusedOut = true;
      validated = false;
    }
    if (isNull(model.idtabprecobonificacao)||model.idtabprecobonificacao==0) {
      refs.tabPrecoBonificacaoSelect.focusedOut = true;
      validated = false;
    }
    if (isNull(model.coeftabpreco)||!this.validateQuantidade(model.coeftabpreco)) {
      refs.coeficientePreco.focusedOut = true;
      validated = false;
    }
    if (isNull(model.ignoraregraflex)) {
      refs.flex.focusedOut = true;
      validated = false;
    }
    if (isNull(model.contribuinteicms)) {
      refs.icms.focusedOut = true;
      validated = false;
    }
    if (isNull(model.farmpopular)) {
      refs.farmacia.focusedOut = true;
      validated = false;
    }
    if (isNull(model.prazoentrega)||!this.validateQuantidade(model.prazoentrega)) {
      refs.prazo.focusedOut = true;
      validated = false;
    }
    if (isNull(model.frequenciacompra)||!this.validateQuantidade(model.frequenciacompra)) {
      refs.frequencia.focusedOut = true;
      validated = false;
    }
    if (isNull(model.valorminimocif)||!this.validateQuantidade(model.valorminimocif)) {
      refs.cif.focusedOut = true;
      validated = false;
    }
    if (isNull(model.valorminimofob)||!this.validateQuantidade(model.valorminimofob)) {
      refs.fob.focusedOut = true;
      validated = false;
    }
    if (isNull(model.estoqueseguranca)||!validatePorcentagem(model.estoqueseguranca)) {
      refs.estoqueSeguranca.focusedOut = true;
      validated = false;
    }
    
    return validated;
  }

  validateQuantidade(valor){
    return valor >= 0 && valor <= 99999999.99; 
  }
}